export function isSymbolCounterLimitReached({ currentLength, maxLength }) {
  return Boolean(maxLength) && currentLength >= maxLength
}

export function isSymbolCounterLimitExceeded({ maxLength, value }) {
  return Boolean(maxLength) && getSymbolCounterTextLength(value) > maxLength
}

/**
 * Default function to get text length.
 *
 * @param {string} value
 * @returns {number}
 */
export function getSymbolCounterTextLength(value) {
  return (value && value.length) || 0
}
